import config from '../config.js';
import { nextTick } from 'vue'
import dataStore from '../store/index'

let areatpl = `<div class="fenye-wrap">
                <div class="fenye-area">
                  <p class="fenye-area-line"></p>
                </div>
              </div>`;
// let a4Heigth = config.pageSizeType['a4'][1] || 842;
// console.log('a4Heigth:', a4Heigth)
export const appendSafeAreaEle = function (callback) {
  try {
    let tpl_boxEle = document.getElementById('tpl_box');
    if (!tpl_boxEle) return;
    let a4Heigth = parseInt(tpl_boxEle.dataset.containerminheightpx) || window.pageHeightSize || 842;
    let boxScale = window.previewScale || 1;
    a4Heigth = parseInt(a4Heigth);
    // 先移除可能已经存在的
    while(document.querySelectorAll('.fenye-wrap') && document.querySelectorAll('.fenye-wrap').length) {
      tpl_boxEle.removeChild(document.querySelectorAll('.fenye-wrap')[0]);
    };
    let elelientRect = tpl_boxEle && tpl_boxEle.getBoundingClientRect();
    if (elelientRect && elelientRect.height) {
      if (elelientRect.height < a4Heigth && boxScale < 1) {
        elelientRect.height = elelientRect.height / boxScale;
      }
      //  判断几页a4纸
      let pageSize = (elelientRect.height / a4Heigth <= 1) ? 1 : Math.floor(elelientRect.height / a4Heigth) + 1;
      console.log('pageSize====>', pageSize, elelientRect.height / a4Heigth, 'boxScale:', boxScale);
      // if (pageSize < 2) return;
      // 如果大于1页就会有分页线 分页线数 = 页面数 - 1
      // 插入分页线
      for (let index = 0; index < pageSize - 1; index++) {
        tpl_boxEle.insertAdjacentHTML('afterBegin', areatpl);
      }
      // 遍历给每一个分页线给定位样式
      let areatplEles = document.querySelectorAll('.fenye-wrap');
      // if (areatplEles.length <= 0) return;
      for (let index = 0; index < areatplEles.length; index++) {
        let element = areatplEles[index];
        if (element) {
          // 计算top值 
          let topVal = a4Heigth * (index + 1) - 30 - 3;
          element.style.top = topVal + 'px';
        }
      }
    } else {
      console.log('elelientRect fail:', elelientRect)
    }
    callback && callback();
  } catch (error) {
    callback && callback();
  }
}

export const checkItemWaring = () => {
  try {
    let hasItemWaring = false;
    let itemWaringEle = null
    // 获取所有独立判断块
    let content_list_commonEles = document.querySelectorAll('.content_list_common');
    let fenye_wrapEles = document.querySelectorAll('.fenye-wrap');
    // if (fenye_wrapEles.length <= 0) return;
    // 遍历这些块 对比每一个块区域的上边框和下边框 判断是否都跨越了安全区域的上下边框
    // if (content_list_commonEles.length <= 0) return;
    for (let index = 0; index < content_list_commonEles.length; index++) {
      content_list_commonEles[index] && content_list_commonEles[index].classList.remove('waring-itemcls');
    }
    for (let index = 0; index < content_list_commonEles.length; index++) {
      let element = content_list_commonEles[index];
      let elementClientRect = element && element.getBoundingClientRect();
      if (elementClientRect && elementClientRect.top && elementClientRect.bottom) {
        // 获取所有分页线的安全区  遍历他们
        for (let index = 0; index < fenye_wrapEles.length; index++) {
          let fenyeelement = fenye_wrapEles[index];
          let fenyeelementClientRect = fenyeelement && fenyeelement.getBoundingClientRect();
          // 对比他们的上线边界
          if (fenyeelementClientRect
            && fenyeelementClientRect.top >=  elementClientRect.top
            && (fenyeelementClientRect.bottom - 30) <= elementClientRect.bottom) {
              // 这项独立块是跨越安全区域的  给他警告类样式
              element.classList.add('waring-itemcls');
              hasItemWaring = true;
              itemWaringEle = element;
          }
        }
      };
    }
    return {
      hasItemWaring,
      itemWaringEle
    };
  } catch (error) {
    return {
      hasItemWaring: false,
      itemWaringEle: null
    };;
  }
}
let ischecking = false;
export const dymicItemWaringFn = () => {
  if (ischecking) return;
  !ischecking && (ischecking = true);
  return new Promise((resolve, reject) => {
    if (!dataStore.state.openCheckMaring) {
      let tpl_boxEle = document.getElementById('tpl_box');
      while(document.querySelectorAll('.fenye-wrap') && document.querySelectorAll('.fenye-wrap').length) {
        tpl_boxEle.removeChild(document.querySelectorAll('.fenye-wrap')[0]);
      };
      let content_list_commonEles = document.querySelectorAll('.content_list_common');
      for (let index = 0; index < content_list_commonEles.length; index++) {
        content_list_commonEles[index] && content_list_commonEles[index].classList.remove('waring-itemcls');
      }
      ischecking = false;
      resolve({
        hasItemWaring: false,
        itemWaringEle: null
      });
    } else {
      nextTick(() => {
        console.log('appendSafeAreaEle===>')
        appendSafeAreaEle(() => {
          // let checkRsp = checkItemWaring();
          ischecking = false;
          resolve({
            hasItemWaring: false,
            itemWaringEle: null
          });
        });
      })
    }
  }).catch(err => console.log(err))
}

export const setfenyeWrapShowOrHide = (type = 'show') => {
  try {
      let areatplEles = document.querySelectorAll('.fenye-wrap');
      if (areatplEles.length <= 0) return;
      for (let index = 0; index < areatplEles.length; index++) {
        let element = areatplEles[index];
        if (element) {
          element.style.display = type == 'show' ? 'block' : 'none';
        }
      }
      // let content_list_commonEles = document.querySelectorAll('.content_list_common');
      // for (let index = 0; index < content_list_commonEles.length; index++) {
      //   content_list_commonEles[index] && content_list_commonEles[index].classList.remove('waring-itemcls');
      // }
  } catch (error) {
  }
}